import { Observable, throwError, throwError as observableThrowError } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpInterceptorService, RESTService } from '@covalent/http-deprec';
import { CSVDocument } from './Model/CSVDocument';
import { MaklerPaketStatus } from "./Model/MaklerPaketStatus";
import { catchError, map } from "rxjs/operators";
import { TeilpaketKraft } from "./Model/TeilpaketKraft";
import { HttpHeaders } from '@angular/common/http';
import {UserInfo} from "./Model/UserInfo";

@Injectable()
export class CsvUploadService extends RESTService<File> {

  constructor(public http: HttpInterceptorService) {
    super(http, {
      baseUrl: `${environment.apiHost}`,
      path: '/makpak/setLieferungRequest'
    });
  }

  uploadCSV(file: File, bensl: string): Observable<boolean> {
    let userId = bensl;
    let sendingData = new CSVDocument("dummy", file.name, file);
    return super.create(file).pipe(
      map((res: boolean) => {
        return res;
      }));
  }

  uploadFile(file: File) {
    let formData: FormData = new FormData();
    formData.append("file", file);
    formData.append("name", file.name);
    formData.append("mimeType", "");
    this.http.post(`${environment.apiHost}` + 'makpak/setLieferungRequest', formData).pipe(
      map(res => res.json()),
      catchError(error => observableThrowError(error))
    ).subscribe(
      data => console.log('success'),
      error => console.log(error)
    );

  }

  //SecureUpload
  secureUploadFile(file: File, wert: string, text: string, bezeichnung: string): Observable<MaklerPaketStatus> {
    let formData: FormData = new FormData();
    formData.append("file", file);
    formData.append("maklerPaket", wert + ";" + text + ";" + bezeichnung + ";" + file.name);
    return this.http.post(`${environment.apiHost}` + '/makpak/fileupload', formData).pipe(
      map(res => res.json()),
      catchError(error => observableThrowError(error)),
      map((result: MaklerPaketStatus) => {
        console.log("to MaklerPaketStatus?");
        if (result != null) {
          return result;
        }
        console.log(result);
      }));
  }

   uploadMakpakKraftForCheck(file: any, teilpaketKraft: TeilpaketKraft, bensl: string, linkEnd:String): Observable<any> {
    let formData: FormData = new FormData();
    formData.append("file", linkEnd.indexOf('/makpak/setorder')>0?file:JSON.stringify(file));
    formData.append("maklerPaket", JSON.stringify(teilpaketKraft));
    formData.append("bensl", bensl);
    const httpOptions: { responseType; } = {
      responseType: 'text'
    };
    return this.http.post(`${environment.apiHost}` + linkEnd, formData).pipe(
      map(res => res.json()),
      catchError(error => throwError(error)),
      map((result: any) => {
        if (result != null) {
          return JSON.parse(JSON.stringify(result));
        }
        console.log(result);
      }));
  }

  uploadMakpakKraftCheckResult(teilpaketKraft: TeilpaketKraft, bensl: string, linkEnd:String): Observable<any> {
    let formData: FormData = new FormData();
    formData.append("maklerPaket", JSON.stringify(teilpaketKraft));
    formData.append("bensl", bensl);
    const httpOptions: { responseType; } = {
      responseType: 'text'
    };
    return this.http.post(`${environment.apiHost}` + linkEnd, formData).pipe(
      map(res => res.json()),
      catchError(error => throwError(error)),
      map((result: any) => {
        if (result != null) {
          return JSON.parse(JSON.stringify(result));
        }
        console.log(result);
      }));
  }

   uploadMakpakKraftForSave(file: any, teilpaketKraft: TeilpaketKraft, bensl: string):Observable<any> {
       let formData: FormData = new FormData();
       formData.append("file", JSON.stringify(file));
       formData.append("maklerPaket", JSON.stringify(teilpaketKraft));
       formData.append("bensl", bensl);
      return this.http.post(`${environment.apiHost}` + '/makpak/mphist', formData).pipe(
        map(res => res.json()),
        catchError(error => throwError(error)),
        map((result: any) => {
          if (result != null) {
            return JSON.parse(JSON.stringify(result));
          }
          console.log(result);
        }));
  }

  uploadCheckedJson(file: any, teilpaketKraft: TeilpaketKraft, bensl: string): Observable<any> {
    let formData: FormData = new FormData();
    formData.append("file", file);
    formData.append("maklerPaket", JSON.stringify(teilpaketKraft));
    formData.append("bensl", bensl);
    return this.http.post(`${environment.apiHost}` + '/makpak/mphist', formData).pipe(
      map(res => res.json()),
      catchError(error => throwError(error)),
      map((result: any) => {
        if (result != null) {
          return result;
        }
        console.log(result);
      }));
  }

  uploadMakpakKraft(file: File, teilpaketKraft: any): Observable<any> {
    const seperator = "?,";
    let formData: FormData = new FormData();
    formData.append("file", file);
    formData.append("maklerPaket", JSON.stringify(teilpaketKraft));
    console.log("Will send data with name " + teilpaketKraft.beschreibung);
    return this.http.post(`${environment.apiHost}` + '/makpak/mporigin', formData).pipe(
      map(res => res.json()),
      catchError(error => throwError(error)),
      map((result: any) => {
        if (result != null) {
          return result;
        }
        console.log(result);
      }));
  }

}
